var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9211 5H6.07895C5.21053 5 4.5 5.7 4.5 6.55556V17.4444C4.5 18.3 5.21053 19 6.07895 19H17.9211C18.7895 19 19.5 18.3 19.5 17.4444V6.55556C19.5 5.7 18.7895 5 17.9211 5ZM17.9211 6.55556V8.88889H6.07895V6.55556H17.9211ZM13.9737 17.4444H10.0263V10.4444H13.9737V17.4444ZM6.07895 10.4444H8.44737V17.4444H6.07895V10.4444ZM15.5526 17.4444V10.4444H17.9211V17.4444H15.5526Z",
    fill: "#272932"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreen);
export default __webpack_public_path__ + "static/media/full_screen.05073313ff7a07313d08bc981d39e96c.svg";
export { ForwardRef as ReactComponent };